export default "__VITE_ASSET__0vHveH7R__"